module.exports = __webpack_public_path__ + "img/logo4.7f1bf8e6.gif";